import get from 'transmute/get';
export const isKnownContact = (contact = null) => {
  return contact ? get('is-contact', contact) : false;
};